import React from "react";
import { Link } from "react-router-dom";
import IdeaStatusBadge from "./IdeaStatusBadge";
import { categoryLabel } from "../../api/ideas";
import { HeartIcon, CommentIcon } from "./IdeasIcons";

/**
 * Карточка идеи. Кликабельна. Цветная статус-полоса слева через
 * data-status в CSS. Категория-чип через data-cat. Аватар-инициал автора.
 */
export default function IdeaCard({ idea }) {
    const initial = (idea.author_name || "?").trim().charAt(0).toUpperCase() || "?";

    return (
        <Link
            to={`/ideas/${idea.id}`}
            className="idz-card"
            data-status={idea.status}
        >
            <div className="idz-card-head">
                <span className="idz-card-cat" data-cat={idea.category}>
                    {categoryLabel(idea.category)}
                </span>
                <IdeaStatusBadge status={idea.status} />
            </div>
            <h3 className="idz-card-title">{idea.title}</h3>
            <p className="idz-card-desc">{idea.description}</p>
            <div className="idz-card-footer">
                <span className="idz-card-author">
                    <span className="idz-card-author-dot">{initial}</span>
                    {idea.author_name || `автор #${idea.author_id}`}
                </span>
                <div className="idz-card-stats">
                    <span className={"idz-stat" + (idea.is_liked ? " is-liked" : "")}>
                        <HeartIcon /> {idea.likes}
                    </span>
                    <span className="idz-stat">
                        <CommentIcon /> {idea.comments}
                    </span>
                </div>
            </div>
        </Link>
    );
}
